<template>
  <div>
    <div class="main-title">业务员列表</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="add()">添加业务员</el-button>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索业务员姓名/身份证/手机号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              style="width:250px;"
              @input="inputSearch(searchForm)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column
          prop="name"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号">
        </el-table-column>
        <el-table-column
          prop="idcard"
          label="身份证号">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="update(scope.row)">修改</el-button>
            <el-button type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 业务员修改窗口 -->
    <el-dialog :title="updateSecuTitle" :visible.sync="updateSecuVisible">
      <el-form :model="secuForm" ref="secuForm" :rules="secuFormRules" label-width="200px">
        <el-form-item prop="name" label="姓名" v-if="modelType == 'add'">
          <el-input v-model="secuForm.name" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item prop="sex" label="性别">
          <el-select v-model="secuForm.sex" style="width:194px;">
            <el-option label="男" value="男"></el-option>
            <el-option label="女" value="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="secuForm.phone" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="secuForm.idcard" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="secuForm.status" placeholder="请选择" style="width:194px;">
            <el-option  label="在职" value="在职"></el-option>
            <el-option  label="离职" value="离职"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateCommit" :loading="updateCommiting">确 定</el-button>
        <el-button @click="updateSecuVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import moment from 'moment'
export default {
  mixins: [ListFunc],
  data () {
    return {
      sqlcode: 'sales_list',
      companyList: [],
      searchForm: {
        query: ''
      },
      secuForm: {
        id: 0,
        name: '',
        sex: '男',
        phone: '',
        idcard: '',
        company_id: null,
        status: '在职',
        name_pinyin: '',
        name_py: ''
      },
      updateSecuTitle: '修改业务员信息',
      updateSecuVisible: false,
      updateCommiting: false,
      companyList: [],
      modelType: ""
    }
  },
  computed: {
    secuFormRules() {
      return {
        name: [
          { required: true, message: "请填写姓名", trigger: "blur" }
        ],
        sex: [
          { required: true, message: "选择性别", trigger: "blur" }
        ],
        company_id: [
          { required: true, message: "选择所属集团", trigger: "blur" }
        ]
      }
    },
    searchParams () {
      return {
        query: this.searchForm.query
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.status === '离职') {
        return 'row-red';
      }
      return '';
    },
    cleanForm () {
      this.secuForm = {
        id: 0,
        name: '',
        sex: '男',
        phone: '',
        idcard: '',
        company_id: null,
        status: '在职',
        name_pinyin: '',
        name_py: ''
      }
    },
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
        }
      })
    },
    updateCoach (row) {
      this.modelType = 'update'
      this.updateSecuTitle = '修改业务员信息'
      this.secuForm = {
        id: row.id,
        name: row.name,
        sex: row.sex,
        phone: row.phone,
        idcard: row.idcard,
        company_id: row.company_id,
        status: row.status,
        name_pinyin: row.name_pinyin,
        name_py: row.name_py
      }
      this.updateSecuVisible = true
    },
    updateCommit () {
      let url = ''
      let postForm = {}
      if (this.modelType === '') { return false }
      if (this.modelType === 'update') {
        url = '/dbapi/update_sales'
        postForm = this.secuForm
      } else {
        url = '/dbapi/insert_sales'
        let addobj = this.secuForm
        delete addobj.id
        postForm = addobj
        postForm.name_py = addobj.name
        postForm.name_pinyin = addobj.name
      }
      this.updateCommiting = true
      this.$refs['secuForm'].validate(valid => {
        if (valid) {
          if (this.modelType === 'add') {
            this.$http.get('/dbapi/sales_info_byname?name=' + postForm.name).then(res => {
              if (res.data.success && res.data.list.length > 0) {
                this.$alert('已存在相同姓名业务员，请检查是否重复添加或使用其他昵称', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.updateCommiting = false
                    return false
                  }
                })
              } else {
                this.postAction(url, postForm)
              }
            })
          } else {
            this.postAction(url, postForm)
          }
        } else {
          console.log("error submit!!")
          this.updateCommiting = false
          return false
        }
      })
    },
    add () {
      this.modelType = 'add'
      this.updateSecuVisible = true
      this.updateSecuTitle = '添加业务员信息'
    },
    del (row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/del_sales', { id: row.id }).then(res => {
          if (res.data.success) {
            this.refresh()
          } else {
            this.$message({
              type: "error",
              message: "网络错误，请稍后重试"
            })
            console.log(res)
          }
        })
      })
    },
    postAction (url, postForm) {
      this.$http
      .post(url, postForm)
      .then(res => {
        this.updateCommiting = false
        if (res.data.success) {
          this.cleanForm()
          this.refresh()
          this.updateSecuVisible = false
          this.modelType = ""
        } else {
          this.$message({
            type: "error",
            message: response.data.message
          })
        }
      })
    },
    update (row) {
      this.updateSecuTitle = `信息修改：${row.name}`
      this.modelType = 'update'
      this.secuForm = {
        id: row.id,
        name: row.name,
        sex: row.sex,
        phone: row.phone,
        idcard: row.idcard,
        status: row.status,
      }
      this.updateSecuVisible = true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/data/Sales.vue